import React, { Component } from 'react';
import Button from "../elements/Button";
import globals from '../globals';

class ImagePanel extends Component {

    componentDidMount() {
        this.controller = globals.genericAnimation(this.content);
    }

    componentWillUnmount() {
        globals.destroy(this.controller);
    }

    render() {
        this.align = (this.props.align ? this.props.align : 'left');
        this.className = (this.props.className ? this.props.className : '');
        this.hasWave = (this.props.hasWave ? this.props.hasWave : false);
        this.description = (this.props.data.description ? this.props.data.description : []);

        const Description = this.description.map((paragraph, key) => {
            return (
                <p key={key} dangerouslySetInnerHTML={{__html: paragraph}} />
            );
        });

        return (
            <section className={'image-panel ' + this.className + ' ' + this.align}>
                <div className="flex-row">
                    <div className="flex-column centered image">
                        <img src={this.props.data.image} alt={this.props.data.title} />
                    </div>
                    <div className="flex-column" ref={el => this.content = el}>
                        <h3 dangerouslySetInnerHTML={{__html: this.props.data.title}} />
                        {Description}

                        { (this.props.data.url && this.props.data.url !== '' ? <Button action={this.props.data.url} image={this.props.data.buttonImg} alt="" /> : '') }
                    </div>
                </div>
                { (this.hasWave ? <div className="bottom-wave-darkgreen" /> : '') }
            </section>
        );
    }

}

export default ImagePanel;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/ImagePanel.js